<template>
    <el-button @click="shareKakaoMessage">전송</el-button>
</template>

<script>
    let kakaoScript = null;

    export default {
        name: 'ExportKakao',
        components: {
        },
        props: {},
        data() {
            return {}
        },
        beforeRouterEnter() {},
        created() {

            this.initKaKaoJs();
        },
        mounted() {


        },
        beforeDestroy() {
            this.destoryKaKaoJs();
        },
        destroyed() {},
        computed: {
        },
        methods:{
            initKaKaoJs() {
                kakaoScript = document.createElement('script');
                kakaoScript.setAttribute('src', 'http://developers.kakao.com/sdk/js/kakao.min.js');
                kakaoScript.onload = () => {
                    Kakao.init('4a88027951424782c68142aeaa6d48a6');
                    this.shareKakaoMessage();
                }
                document.head.appendChild(kakaoScript);
            },
            destoryKaKaoJs() {

            },
            makeShareButton() {

            },
            shareKakaoMessage() {
                Kakao.Link.sendDefault({
                    objectType: 'feed',
                    content: {
                        title: '디저트 사진',
                        description: '아메리카노, 빵, 케익',
                        imageUrl:
                            'http://mud-kage.kakao.co.kr/dn/NTmhS/btqfEUdFAUf/FjKzkZsnoeE4o19klTOVI1/openlink_640x640s.jpg',
                        link: {
                            mobileWebUrl: 'https://developers.kakao.com',
                            androidExecParams: 'test',
                        },
                    },
                    buttons: [
                        {
                            title: '웹으로 이동',
                            link: {
                                mobileWebUrl: 'https://developers.kakao.com',
                            },
                        },
                        {
                            title: '앱으로 이동',
                            link: {
                                mobileWebUrl: 'https://developers.kakao.com',
                            },
                        },
                    ],
                    success: function(response) {
                        alert(response);
                    },
                    fail: function(error) {
                        console.log(error);
                        alert(error);
                    }
                });
            },
        },
        watch: {

        },
    }
</script>
